import React, { useState } from "react";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";

export default function TableOfContents({ items }) {
  const [isOpen, setIsOpen] = useState(true);

  if (!items || items.length === 0) return null;

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="bg-light-gray/5 rounded-lg border border-stroke p-6 mb-8">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center justify-between w-full text-left mb-4"
      >
        <h2 className="text-18 font-medium text-secondary">Table of Contents</h2>
        {isOpen ? (
          <FiChevronUp className="w-5 h-5 text-light-gray" />
        ) : (
          <FiChevronDown className="w-5 h-5 text-light-gray" />
        )}
      </button>
      
      {isOpen && (
        <nav>
          <ul className="space-y-2">
            {items.map((item, index) => (
              <li key={index}>
                <button
                  onClick={() => scrollToSection(item.id)}
                  className="text-14 text-light-gray hover:text-primary transition-colors text-left"
                  style={{ paddingLeft: `${(item.level - 1) * 16}px` }}
                >
                  {item.text}
                </button>
              </li>
            ))}
          </ul>
        </nav>
      )}
    </div>
  );
}
